import { defineStore } from "pinia";
import { ref } from "vue";

import { asReadonly } from "@/utils/vue";

import { toggleFunc } from "./helpers/toggle";

export const useBoardConfigStore = defineStore("boardConfig", () => {
  const active = ref(false);

  return {
    active: asReadonly(active),
    toggle: toggleFunc(active),
  };
});
